export default __webpack_public_path__ + "static/media/setion03_bg_m.328a15e4.png";